import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const AppsScreen = React.lazy(() => import("./screens/apps"));

const AppRoutes = () => {
  return (
    <BrowserRouter basename="/">
      <React.Suspense>
        <Routes>
          <Route path="/" element={<AppsScreen />} />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
};

export default AppRoutes;
